import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet';
import IndexPagePhoto from "../components/IndexPagePhoto";


class IndexPage extends React.Component {

    constructor(props) {
        super(props);

        const {data} = this.props;
        const {markdownRemark: page} = data;
        const photos = page.frontmatter.photos;
        const pairedPhotos = [];

        for (let i = 0; i < photos.length; i += 2) {
            let pair = [];
            if (photos[i])
                pair.push(photos[i]);
            if (photos[i + 1])
                pair.push(photos[i + 1]);
            pairedPhotos.push(pair);
        }

        this.state = {
            page: page.frontmatter,
            photosInPair: pairedPhotos
        };

    }

    render() {
        return (
            <section className="section body section-content-wrapper">
                <Helmet
                    title={`${this.state.page.title}`}
                    bodyAttributes={{
                        class: "page-home theme-orange"
                    }}/>

                <div className="projects">
                    {
                        this.state.photosInPair.map((photo, index) => {
                            return (
                                <div key={index} className="project columns">
                                    <IndexPagePhoto
                                        link = {photo[0].link}
                                        mainImageUrl={photo[0].mainImageUrl}
                                        hoverImageUrl={photo[0].hoverImageUrl}
                                        caption={photo[0].caption}
                                        color={photo[0].color}
                                        isNarrow={true}/>
                                    {
                                        photo[1] ?
                                            <IndexPagePhoto
                                                link = {photo[1].link}
                                                mainImageUrl={photo[1].mainImageUrl}
                                                hoverImageUrl={photo[1].hoverImageUrl}
                                                caption={photo[1].caption}
                                                color={photo[1].color}
                                                isNarrow={false}/>

                                            : null
                                    }
                                </div>
                            )
                        })}

                </div>

            </section>

        );
    }
}

IndexPage.propTypes = {
    data: PropTypes.shape({
        markdownRemark: PropTypes.object
    })
}
export default IndexPage;

export const indexPageQuery = graphql`
  query IndexPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        description
        photos{
          mainImageUrl
          hoverImageUrl
          caption
          color
          link
        }
      }
    }
    
  }
`


// WEBPACK FOOTER //
// ./src/templates/index.js